<template>
  <div class="wrapper">
    <el-row v-if="message.inapp_type !== inAppTypes.INLINE">
      <el-col :span="12">
        <form-item class="select">
          <el-select
            v-model="screenSize"
            placeholder="Select"
            value-key="label"
            class="p-bottom-20"
          >
            <el-option-group
              v-for="group in screenSizesOptions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.label"
                :label="item.label"
                :value="item"
              >
              </el-option>
            </el-option-group>
            <el-option-group>
              <el-option label="Custom" :value="customScreenSize" />
            </el-option-group>
          </el-select>
        </form-item>
      </el-col>
      <el-col :span="12">
        <el-row>
          <el-col :span="12">
            <form-item>
              <el-input-number
                :disabled="screenSize.hasOwnProperty('label')"
                controls-position="right"
                v-model="customScreenSize.width"
                :min="240"
                :max="3200"
                placeholder="width"
              />
            </form-item>
          </el-col>
          <el-col :span="12">
            <form-item>
              <el-input-number
                :disabled="screenSize.hasOwnProperty('label')"
                controls-position="right"
                v-model="customScreenSize.height"
                :min="240"
                :max="3200"
                placeholder="height"
              />
            </form-item>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <div v-if="message.inapp_type === inAppTypes.INLINE">
      <native-inline-preview :message="message.inapp" />
    </div>

    <phone-new
      v-else
      class="phone"
      :width="resolution.width + 'px'"
      :height="resolution.height + 'px'"
      :type="screenSize.type"
      :orientation="orientation"
    >
      <div v-if="message.inapp_type === inAppTypes.HTML">
        <iframe
          v-if="message.inapp.html"
          :srcdoc="message.inapp.html"
          class="html-preview"
          :class="orientation"
          :style="{ height: `${resolution.width}px` }"
        ></iframe>
      </div>
      <div
        v-else
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
        class="preview"
        :class="positionClass"
      >
        <div
          v-if="preview && orientation === 'portrait'"
          class="preview-portrait"
          :class="{ 'preview-modal': message.inapp_type === inAppTypes.MODAL }"
        >
          <template v-if="message.inapp_type === inAppTypes.BANNER">
            <div class="creative" v-if="preview.background_file">
              <img
                alt=""
                class="image"
                :src="preview.background_file"
                :style="{
                  height: getHeight(preview.height),
                  width: 'auto'
                }"
              />
            </div>
            <div
              v-else
              class="creative placeholder"
              :style="{
                height: getHeight(preview.height),
                width: 'auto'
              }"
            >
              <img class="image" src="/img/mobile/watermark.png" alt="" />
            </div>
          </template>
          <template v-if="message.inapp_type === inAppTypes.FULLSCREEN">
            <div class="full" ref="fullscreen" :style="fullStyles">
              <div
                v-if="!message.inapp.placeholder[orientation].background"
                class="creative placeholder"
                :style="{
                  height: '100%',
                  width: 'auto'
                }"
              >
                <img class="image" src="/img/mobile/watermark.png" alt="" />
              </div>
              <div class="background-wrapper" :style="bgWrapperStyles">
                <img
                  v-if="message.inapp.placeholder[orientation].background"
                  :src="message.inapp.placeholder[orientation].background"
                  @load="bgLoaded"
                  class="bg-image"
                />
                <div class="objectx"></div>
                <div class="objecty"></div>
                <img
                  class="draggable"
                  :key="key"
                  v-for="(button, key) in message.inapp.buttons"
                  @mouseup="dragMouseUp(key)"
                  :src="button[orientation].background_file"
                  :style="buttonStyles(button)"
                />
                <div
                  class="draggable"
                  style="width: 100%;height: 100%;z-index: -1;position: absolute;top:0"
                ></div>
              </div>
            </div>
          </template>
          <template v-if="message.inapp_type === inAppTypes.MODAL">
            <div class="overlay" :style="overlayStyles"></div>
            <div class="modal" :style="modalStyles">
              <div
                v-for="(item, seqIndex) in message.inapp.editor.sequence"
                :key="seqIndex"
              >
                <div
                  v-if="item === 'image' && message.inapp.editor.image_checkbox"
                  class="image"
                >
                  <img :src="modalImageSrc" :style="modalImageStyles" />
                </div>
                <div
                  v-if="item === 'title'"
                  class="title"
                  :style="titleStyles"
                  v-html="message.inapp.editor.title"
                ></div>
                <div
                  v-if="item === 'text'"
                  class="text"
                  :style="textStyles"
                  v-html="message.inapp.editor.main_text"
                ></div>
                <div v-if="item === 'buttons'" class="buttons">
                  <el-row>
                    <el-col
                      :style="buttonCol"
                      v-if="message.inapp.editor.button0.enabled === 'on'"
                    >
                      <div class="button" :style="button0Styles">
                        {{
                          message.inapp.editor.button0.text
                            ? message.inapp.editor.button0.text
                            : $t('CampaignForm_InApp_Preview_Button0_Default')
                        }}
                      </div>
                    </el-col>
                    <el-col
                      :style="buttonCol"
                      v-if="message.inapp.editor.button1.enabled === 'on'"
                    >
                      <div class="button" :style="button1Styles">
                        {{
                          message.inapp.editor.button1.text
                            ? message.inapp.editor.button1.text
                            : $t('CampaignForm_InApp_Preview_Button1_Default')
                        }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div
                  v-if="
                    item === 'inline-preferences' &&
                      message.inapp.editor.inline_preference &&
                      message.inapp.editor.inline_preference.enabled
                  "
                  class="inline-preferences"
                >
                  <el-row>
                    <el-col :span="2">
                      <input
                        type="checkbox"
                        :style="{
                          accentColor:
                            message.inapp.editor.color_inline_checkbox
                        }"
                        checked
                        onclick="return false;"
                      />
                    </el-col>
                    <el-col :span="22">
                      <span
                        class="opt-in-text"
                        :style="{
                          color: message.inapp.editor.color_inline_text
                        }"
                        >{{
                          message.inapp.editor.inline_preference.opt_in
                        }}</span
                      >
                    </el-col>
                  </el-row>
                  <div class="buttons">
                    <el-row style="text-align: center">
                      <el-col>
                        <div class="button" :style="inlineButtonStyles">
                          {{ message.inapp.editor.inline_preference.button }}
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div
          v-else-if="preview"
          class="preview-landscape"
          :class="message.inapp.placeholder.position"
          :style="{ height: resolution.width + 'px' }"
        >
          <template v-if="message.inapp_type === inAppTypes.BANNER">
            <div class="creative" v-if="preview.background_file">
              <img
                alt=""
                class="image"
                :src="preview.background_file"
                :style="{
                  height: getHeight(preview.height),
                  width: 'auto',
                  top: (preview.height - preview.min_width) / 2 + 'px',
                  left: -(preview.height - preview.min_width) / 2 + 'px'
                }"
              />
            </div>
            <div
              v-else
              class="creative placeholder"
              :style="{
                height: getHeight(preview.height),
                width: '480px',
                top: (preview.height - preview.min_width) / 2 + 'px',
                left: -(preview.height - preview.min_width) / 2 + 'px'
              }"
            >
              <img class="image" src="/img/mobile/watermark.png" alt="" />
            </div>
          </template>
          <template v-if="message.inapp_type === inAppTypes.FULLSCREEN">
            <div class="full" ref="fullscreen" :style="fullStyles">
              <div
                v-if="!message.inapp.placeholder[orientation].background"
                class="creative placeholder"
                :style="{
                  height: '100%',
                  width: 'auto'
                }"
              >
                <img class="image" src="/img/mobile/watermark.png" alt="" />
              </div>
              <div class="background-wrapper" :style="bgWrapperStyles">
                <img
                  v-if="message.inapp.placeholder[orientation].background"
                  :src="message.inapp.placeholder[orientation].background"
                  class="bg-image"
                />

                <div class="objectx"></div>
                <div class="objecty"></div>
                <img
                  class="draggable"
                  :key="key"
                  v-for="(button, key) in message.inapp.buttons"
                  @mouseup="dragMouseUp(key)"
                  :src="button[orientation].background_file"
                  :style="buttonStyles(button)"
                />
              </div>

              <div
                class="draggable"
                style="width: 100%;height: 100%;z-index: -1;position: absolute;top:0"
              ></div>
            </div>
          </template>
        </div>
      </div>
    </phone-new>
  </div>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import { screenSizes } from '@/modules/campaign-manage/enum/ScreeenSizes'
import { inAppTypes } from '@/modules/campaign-manage/enum/InAppTypesEnum'
import { toBase64 } from '@/core/helpers'
import PhoneNew from '@/common/components/phone/PhoneNew'
import _ from 'lodash'
import store from '@/core/store'
import { EventBus } from '@/core/EventBus'
import NativeInlinePreview from '@/modules/campaign-manage/components/content/channels/NativeInlinePreview'
export default {
  name: 'InAppPreview',
  components: { NativeInlinePreview, PhoneNew, FormItem },
  props: {
    message: {
      type: Object,
      required: true
    },
    orientation: {
      default: 'portrait'
    }
  },

  mounted() {
    if (store.getters.previewScreenSize) {
      this.screenSize = store.getters.previewScreenSize.screenSize
      this.customScreenSize = store.getters.previewScreenSize.customScreenSize
    } else {
      this.screenSize = this.options[0].options[1]
      this.customScreenSize = {
        width: this.screenSize.width,
        height: this.screenSize.height
      }
    }
    this.updateDraggable()
    this.fixLandScapeFullscreenBackground()
    EventBus.$on('inAppBackgroundUploaded', () => {
      this.fullscreen.backgroundUploaded = true
    })
  },
  destroyed() {
    EventBus.$off('inAppBackgroundUploaded')
  },
  data() {
    return {
      inAppTypes,
      accepts: ['image/gif', 'image/jpeg', 'image/png'],
      previewIndex: 0,
      options: screenSizes,
      screenSize: {},
      customScreenSize: {},
      expanded: false,
      lastDraggedButtonIndex: null,
      fullscreen: {
        backgroundOriginalSize: {
          width: null,
          height: null
        },
        backgroundScale: 1,
        backgroundChanged: false,
        backgroundUploaded: false
      }
    }
  },

  computed: {
    fullStyles() {
      return {}
    },
    bgWrapperPositions() {
      let topOffset = 0
      let leftOffset = 0
      let width = this.fullscreen.backgroundOriginalSize.width
      let height = this.fullscreen.backgroundOriginalSize.height
      this.fullscreen.backgroundScale = 1

      if (this.orientation === 'landscape') {
        if (width === null) {
          width = this.resolution.height
        }
        if (height === null) {
          height = this.resolution.width
        }
        if (width > this.resolution.height) {
          this.fullscreen.backgroundScale = this.resolution.height / width
          width = this.resolution.height
          height = height * this.fullscreen.backgroundScale
          topOffset = -(height - this.resolution.width) / 2
        } else if (
          width < this.resolution.height &&
          height > this.resolution.width
        ) {
          leftOffset = Math.abs(width - this.resolution.height) / 2
          topOffset = -(height - this.resolution.width) / 2
          this.fullscreen.backgroundScale = this.resolution.height / width
        } else if (
          width < this.resolution.height &&
          height < this.resolution.width
        ) {
          topOffset = Math.abs(height - this.resolution.width) / 2
          leftOffset = Math.abs(width - this.resolution.height) / 2
        }
      }
      if (this.orientation === 'portrait') {
        if (width === null) {
          width = this.resolution.width
        }
        if (height === null) {
          height = this.resolution.height
        }
        if (height > this.resolution.height && width < this.resolution.width) {
          this.fullscreen.backgroundScale = this.resolution.width / width
          height = this.resolution.height
          width = width * this.fullscreen.backgroundScale
          topOffset = 0
          leftOffset = Math.abs(width - this.resolution.width) / 2
        } else if (
          height > this.resolution.height &&
          width > this.resolution.width
        ) {
          this.fullscreen.backgroundScale = this.resolution.height / height
          height = this.resolution.height
          width = width * this.fullscreen.backgroundScale
          leftOffset = -(width - this.resolution.width) / 2
          topOffset = 0
        } else if (
          width > this.resolution.width &&
          height < this.resolution.height
        ) {
          this.fullscreen.backgroundScale = this.resolution.width / width
          topOffset = Math.abs(height - this.resolution.height) / 2
          leftOffset = -(width - this.resolution.width) / 2
          this.fullscreen.backgroundScale = 1
        } else {
          topOffset = Math.abs(height - this.resolution.height) / 2
          leftOffset = -(width - this.resolution.width) / 2
        }
      }
      return {
        top: topOffset,
        left: leftOffset,
        width: width,
        height: height
      }
    },
    bgWrapperStyles() {
      return {
        top: `${this.bgWrapperPositions.top}px`,
        left: `${this.bgWrapperPositions.left}px`,
        width: `${this.bgWrapperPositions.width}px`,
        height: `${this.bgWrapperPositions.height}px`
      }
    },
    positionClass() {
      if (this.message.inapp_type === inAppTypes.MODAL) return
      return this.message.inapp.placeholder.position
    },
    button0Styles() {
      return {
        color: this.message.inapp.editor.color_button_0_text,
        backgroundColor: this.message.inapp.editor.color_button_0_background,
        borderColor: this.message.inapp.editor.color_button_0_border
      }
    },
    button1Styles() {
      return {
        color: this.message.inapp.editor.color_button_1_text,
        backgroundColor: this.message.inapp.editor.color_button_1_background,
        borderColor: this.message.inapp.editor.color_button_1_border
      }
    },
    inlineButtonStyles() {
      return {
        color: this.message.inapp.editor.color_inline_button_text,
        backgroundColor: this.message.inapp.editor
          .color_inline_button_background,
        borderColor: this.message.inapp.editor.color_inline_button_border
      }
    },
    titleStyles() {
      return {
        color: this.message.inapp.editor.color_title
      }
    },
    textStyles() {
      return {
        color: this.message.inapp.editor.color_text
      }
    },
    modalStyles() {
      return {
        backgroundColor: `${this.message.inapp.editor.color_background}`,
        borderColor: `${this.message.inapp.editor.color_border}`,
        borderRadius: `${this.message.inapp.editor.color_border_radius}px`
      }
    },
    overlayStyles() {
      return {
        width: '100%',
        height: '100%',
        position: 'absolute',
        backgroundColor: this.message.inapp.editor.color_container,
        opacity: this.message.inapp.editor.opacity_container
          ? this.message.inapp.editor.opacity_container / 100
          : 0
      }
    },
    modalImageSrc() {
      if (this.message.inapp.editor.image) {
        return this.message.inapp.editor.image
      }
      return '/img/inappeditor-placeholder.jpg'
    },
    modalImageStyles() {
      return {
        width: 'auto',
        maxWidth: '100%',
        maxHeight: this.message.inapp.editor.image_height
          ? `${this.message.inapp.editor.image_height}px`
          : 'none',
        height: 'auto'
      }
    },
    activeButtonsCount() {
      if (
        this.message.inapp.editor.button0.enabled === 'on' &&
        this.message.inapp.editor.button1.enabled === 'on'
      ) {
        return 2
      }

      return 1
    },
    buttonCol() {
      return {
        width: this.activeButtonsCount === 1 ? '100%' : '50%',
        textAlign: 'center'
      }
    },
    resolution() {
      let height = 450
      let width = Math.round(
        (height / this.screenSize.height) * this.screenSize.width
      )
      return { width, height }
    },
    preview() {
      let result = null
      if (_.isEmpty(this.message.inapp.creatives[this.orientation])) {
        return null
      }
      let min = Number.MAX_VALUE
      _.forOwn(
        this.message.inapp.creatives[this.orientation],
        (item, index) => {
          // we are looking for creative, which Min Width closest to current screen width,
          // but less that screen width
          let width = item.min_width
          let height = item.height
          let size = this.screenSize.width || 320
          if (
            width >= 0 &&
            height >= 0 &&
            width <= size &&
            size - width < min
          ) {
            min = size - width
            result = item
            this.previewIndex = index
          }
        }
      )

      return result
    },
    screenSizesOptions() {
      let options = screenSizes
      return options
    }
  },

  methods: {
    bgLoaded() {
      if (
        this.fullscreen.backgroundChanged &&
        this.fullscreen.backgroundUploaded
      ) {
        this.fixButtonSizes(true)
        this.fullscreen.backgroundChanged = false
        this.fullscreen.backgroundUploaded = false
      }
    },
    fixLandScapeFullscreenBackground() {
      let placeholder = this.message.inapp.placeholder
      if (
        placeholder[this.orientation] &&
        placeholder[this.orientation].hasOwnProperty('background')
      ) {
        let im = new Image()
        im.src = placeholder[this.orientation].background
        im.onload = () => {
          this.$nextTick(() => {
            this.fullscreen.backgroundOriginalSize.width = im.width
            this.fullscreen.backgroundOriginalSize.height = im.height
          })
        }
      }
    },
    fixButtonSizes(forceCentralize = false) {
      _.forEach(this.message.inapp.buttons, (button, key) => {
        if (
          button[this.orientation] &&
          button[this.orientation].hasOwnProperty('background_file')
        ) {
          let im = new Image()
          im.src = button[this.orientation].background_file
          im.onload = () => {
            this.$nextTick(() => {
              this.$set(
                this.message.inapp.buttons[key][this.orientation],
                'width',
                im.width
              )
              this.$set(
                this.message.inapp.buttons[key][this.orientation],
                'height',
                im.height
              )
              if (
                !button[this.orientation].hasOwnProperty('left') ||
                forceCentralize
              ) {
                // align centre new button
                let leftPositionOffset =
                  ((im.width * this.fullscreen.backgroundScale) /
                    this.bgWrapperPositions.width) *
                  100
                let topPositionOffset =
                  ((im.height * this.fullscreen.backgroundScale) /
                    this.bgWrapperPositions.height) *
                  100
                this.$set(
                  this.message.inapp.buttons[key][this.orientation],
                  'left',
                  50 - leftPositionOffset / 2
                )
                this.$set(
                  this.message.inapp.buttons[key][this.orientation],
                  'top',
                  50 - topPositionOffset / 2
                )
              }
              this.$nextTick(() => {
                this.updateDraggable()
              })
            })
          }
        }
      })
    },
    buttonStyles(button) {
      return {
        top: `${button[this.orientation].top}%`,
        left: `${button[this.orientation].left}%`,
        width: `${button[this.orientation].width *
          this.fullscreen.backgroundScale}px`,
        position: 'absolute'
      }
    },
    dragMouseUp(index) {
      this.lastDraggedButtonIndex = index
    },
    updateDraggable() {
      $('.draggable').draggable({
        containment: '.background-wrapper',
        smartguides: '.draggable',
        tolerance: 7,
        stop: (event, ui) => {
          if (this.lastDraggedButtonIndex !== null) {
            let btnIndex = this.lastDraggedButtonIndex
            this.message.inapp.buttons[btnIndex][this.orientation].left =
              (ui.position.left / this.bgWrapperPositions.width) * 100
            this.message.inapp.buttons[btnIndex][this.orientation].top =
              (ui.position.top / this.bgWrapperPositions.height) * 100
          }
        }
      })
    },
    getHeight(height) {
      return (
        Math.round((height * this.resolution.width) / this.screenSize.width) +
        'px'
      )
    },
    dragover(e) {
      e.preventDefault()
      if (!e.currentTarget.classList.contains('filter')) {
        e.currentTarget.classList.add('filter')
      }
    },
    dragleave(e) {
      e.currentTarget.classList.remove('filter')
    },
    drop(e) {
      e.preventDefault()
      e.currentTarget.classList.remove('filter')
      if (!this.accepts.includes(e.dataTransfer.files[0].type)) {
        this.$message.error(this.$t('CampaignForm_InApp_Preview_UploadError'))
      } else {
        this.setUploadedFile(e.dataTransfer.files[0])
      }
    },
    async setUploadedFile(file) {
      const uploadedFile = await toBase64(file)
      if (this.message.inapp_type === this.inAppTypes.BANNER) {
        if (
          !this.message.inapp.creatives[this.orientation][this.previewIndex]
        ) {
          return
        }

        this.$set(
          this.message.inapp.creatives[this.orientation][this.previewIndex],
          'background_file',
          uploadedFile
        )
      } else if (this.message.inapp_type === this.inAppTypes.FULLSCREEN) {
        this.$set(
          this.message.inapp.placeholder[this.orientation],
          'background',
          uploadedFile
        )
      }
      this.$set(
        this.message.inapp.creatives[this.orientation][this.previewIndex],
        'background_file',
        uploadedFile
      )
    }
  },
  watch: {
    'message.inapp.placeholder': {
      handler() {
        this.fixLandScapeFullscreenBackground()
      },
      deep: true
    },
    'message.inapp.placeholder.portrait.background': {
      handler() {
        this.fullscreen.backgroundChanged = true
      }
    },
    'message.inapp.buttons': {
      handler() {
        this.fixButtonSizes()
      },
      deep: true
    },

    orientation: {
      handler() {
        this.$nextTick(() => {
          this.updateDraggable()
          this.fixButtonSizes()
          this.fixLandScapeFullscreenBackground()
        })
      }
    },
    screenSize: {
      handler(screenSize) {
        if (screenSize.hasOwnProperty('label')) {
          this.customScreenSize.width = screenSize.width
          this.customScreenSize.height = screenSize.height
        }
        store.dispatch('keepScreenSize', {
          screenSize: this.screenSize,
          customScreenSize: this.customScreenSize
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;

  .select {
    margin: 0 auto;
  }
  .phone {
    margin: 20px auto;
    background-color: #ffffff;
  }
  .html-preview {
    border: 0;
    box-sizing: border-box;
    &.portrait {
      width: 100%;
      height: 480px !important;
    }
    &.landscape {
      width: 480px;
    }
  }
  .preview {
    display: flex;
    justify-content: center;
    height: 100%;
    width: 100%;
    background: url('../../../img/checker-transparency.jpg') repeat;
    &.filter {
      filter: brightness(0.7);
    }
    &.center {
      align-items: center;
    }
    &.bottom {
      align-items: flex-end;
    }
    .preview-portrait {
      width: 100%;
      overflow: hidden;
      position: relative;
      &.preview-modal {
        display: flex;
        align-items: center;
      }
    }
    .preview-landscape {
      //transform: rotate(-90deg);
      align-self: center;
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
      &.center {
        display: flex;
        align-items: center;
      }
      &.bottom {
        display: flex;
        align-items: flex-end;
      }
    }
    .creative {
      max-height: 100%;
      width: 100%;
      display: flex;
      overflow: hidden;
      justify-content: center;
      &.placeholder {
        background: rgb(29, 135, 200);
        height: 50px;
        display: flex;
        align-items: center;
        .image {
          max-width: 60%;
          max-height: 100px;
          height: calc(100% - 10px);
          padding: 5px 0;
          object-fit: contain;
        }
      }
    }
    .modal {
      .image {
        text-align: center;
      }
      img {
        width: 100%;
      }
      .title {
        text-align: center;
        font-size: 18px;
      }
      .text {
        text-align: center;
        font-size: 14px;
      }

      .buttons {
        padding: 10px;
      }
      position: inherit;
      overflow: hidden auto;
      max-height: 430px;
      margin: auto;
      width: 90%;
      border: 1px solid transparent;
      .button {
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        display: inline-block;
        margin: 0px;
        font-size: 14px;
        border: 1px solid;
        padding: 7px;
        line-height: 14px;
        text-align: center;
        border-radius: 3px;
      }
      .inline-preferences {
        padding: 3px;
        .el-checkbox {
          float: left;
        }
        .opt-in-text {
          font-size: 11px;
        }
        .el-button {
          margin: 5px;
        }
      }
    }
    .full {
      width: 100%;
      height: 100%;
      background-size: cover;
    }
    .background-wrapper {
      position: absolute;
    }
    .bg-image {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    .objectx {
      display: none;
      width: 1px;
      background-color: yellow;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 10px;
      border-left: none;
    }
    .objecty {
      display: none;
      width: 100%;
      height: 0px;
      position: absolute;
      top: 10px;
      left: 0px;
      border-bottom: 1px solid yellow;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/InAppPreview.vue